// Utility functions for managing referrer cookies

/**
 * Set the referrer cookie to 'app'
 */
export const setReferrerCookie = () => {
  if (typeof document !== 'undefined') {
    document.cookie = 'referrer=app; path=/; max-age=31536000; SameSite=Lax';
  }
};

/**
 * Remove the referrer cookie
 */
export const removeReferrerCookie = () => {
  if (typeof document !== 'undefined') {
    document.cookie = 'referrer=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
};

/**
 * Check if referrer cookie exists and equals 'app'
 */
export const isReferrerApp = (): boolean => {
  if (typeof document === 'undefined') return false;
  
  const cookies = document.cookie.split(';');
  const referrerCookie = cookies.find(cookie => 
    cookie.trim().startsWith('referrer=')
  );
  
  if (referrerCookie) {
    const referrerValue = referrerCookie.split('=')[1];
    return referrerValue === 'app';
  }
  
  return false;
};

/**
 * Initialize referrer cookie from URL parameter if present
 * This should be called on app initialization
 */
export const initializeReferrerFromURL = () => {
  if (typeof window === 'undefined') return;
  
  const urlParams = new URLSearchParams(window.location.search);
  const referrerParam = urlParams.get('referrer');
  
  if (referrerParam === 'app') {
    setReferrerCookie();
    // Remove the parameter from URL without reloading
    urlParams.delete('referrer');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState({}, '', newUrl);
  }
};
